export class FileUploader {
	static Options = {};
	static Lurker = {};

	static Initialize(options) {
		const existingLurker = document.getElementById("ipLurker");

		this.Lurker = existingLurker ?? document.createElementWithContents("input", "", {
			type: "file",
			id: "ipLurker",
			className: "d-none position-absolute"
		});

		if (!existingLurker) {
			document.body.appendChild(this.Lurker);
		}

		this.Options = {
			MaximumSize: 10485760,
			AllowedExtensions: [],
			...options
		};

		if (this.Options.Buttons?.length) {
			[
				...(typeof this.Options.Buttons === "string"
					? document.querySelectorAll(this.Options.Buttons)
					: this.Options.Buttons)
			]
				.filter(x => x != null)
				.forEach(button => {
					button.onclick = () => this.#GetFiles();
				});
		}

		if (this.Options.DropAreas?.length) {
			(
				typeof this.Options.DropAreas === "string"
					? document.querySelectorAll(this.Options.DropAreas)
					: this.Options.DropAreas
			).forEach(area => {
				Object.assign(area ?? {}, {
					ondragenter: ev => ev.preventDefault(),
					ondragover: ev => ev.preventDefault(),
					ondrop: this.#OnDrop
				});
			});
		}
	}

	static #getFileData(buffer) {
		let binary = "";

		const bytes = new Uint8Array(buffer);
		const chunkSize = 0x8000;

		for (let i = 0; i < bytes.length; i += chunkSize) {
			binary += String.fromCharCode(
				...bytes.subarray(i, Math.min(i + chunkSize, bytes.length))
			);
		}

		return btoa(binary);
	}

	static #getImageSrc(buffer, file) {
		return `data:${file.type};base64,${this.#getFileData(buffer)}`;
	}

	static getAuxiliumFile(file) {
		let bufferPromise;

		const getBuffer = () => {
			if (!bufferPromise) {
				bufferPromise = file.arrayBuffer();
			}

			return bufferPromise;
		};

		const auxFile = Object.assign(file, {
			getBuffer,

			getData: async () => {
				const buffer = await getBuffer();

				return this.#getFileData(buffer);
			},

			getImageSrc: async () => {
				const buffer = await getBuffer();

				return this.#getImageSrc(buffer, auxFile);
			},

			compress: async () => {
				return await this.#compressImage(auxFile);
			}
		});

		return auxFile;
	}

	static #compressImage(file, maxWidth = 800, quality = 0.8) {
		return new Promise((resolve, reject) => {
			const img = new Image();

			img.onload = async () => {
				try {
					const scaleSize = Math.min(1, maxWidth / img.width);

					const canvas = document.createElement("canvas");

					canvas.width = img.width * scaleSize;
					canvas.height = img.height * scaleSize;

					const ctx = canvas.getContext("2d");

					if (!ctx) {
						throw new Error("Unable to create canvas context.");
					}

					ctx.drawImage(
						img,
						0,
						0,
						canvas.width,
						canvas.height
					);

					canvas.toBlob(
						async blob => {
							if (!blob) {
								reject(new Error("Unable to compress image."));
								return;
							}

							try {
								const compressedFile = new File(
									[blob],
									file.name.replace(/\.[^/.]+$/, ".jpg"),
									{
										type: "image/jpeg"
									}
								);

								resolve(
									this.getAuxiliumFile(compressedFile)
								);
							} catch (error) {
								reject(error);
							}
						},
						"image/jpeg",
						quality
					);
				} catch (error) {
					reject(error);
				}
			};

			img.onerror = reject;

			file.getImageSrc()
				.then(src => {
					img.src = src;
				})
				.catch(reject);
		});
	}

	static #OnDrop = ev => {
		ev.preventDefault();

		const items = ev.dataTransfer.items;
		const files = ev.dataTransfer.files;

		const processFiles = () => {
			if (items?.length) {
				return this.#ProcessFiles(
					Array.from(items)
						.filter(x => x.kind === "file")
						.map(x => x.getAsFile())
						.filter(x => x != null)
				);
			}

			return this.#ProcessFiles(files);
		};

		if (this.Options.DragDropMessage) {
			Dialog.ShowConfirmation(
				Localizer.CONFIRMATION_TITLE,
				this.Options.DragDropMessage
			).then(proceed => {
				if (proceed) {
					processFiles();
				}
			});

			return;
		}

		processFiles();
	};

	static async #ProcessFiles(receivedFiles) {
		const files = [];

		for (const receivedFile of Array.from(receivedFiles ?? [])) {
			const extension = receivedFile.name
				.split(".")
				.pop()
				.toLowerCase();

			if (
				this.Options.AllowedExtensions.length &&
				!this.Options.AllowedExtensions.some(
					x => x.toLowerCase() === extension
				)
			) {
				continue;
			}

			if (
				receivedFile.size > this.Options.MaximumSize &&
				this.Options.MaximumSize >= 1
			) {
				if (typeof this.Options.OnFileTooLarge === "function") {
					await this.Options.OnFileTooLarge(receivedFile);
				}

				continue;
			}

			files.push(
				this.getAuxiliumFile(receivedFile)
			);
		}

		this.Options.OnComplete?.(files);

		return files;
	}

	static #GetFiles() {
		return new Promise(resolve => {
			Object.assign(this.Lurker, {
				accept: this.Options.AllowedExtensions
					.map(x => `.${x}`)
					.join(","),

				onchange: () => {
					this.#ProcessFiles(this.Lurker.files)
						.then(files => resolve(files));
				}
			});

			if (this.Options.Multiple) {
				this.Lurker.setAttribute("multiple", "");
			}

			if (this.Options.IsDirectory) {
				Object.assign(this.Lurker, {
					directory: "",
					webkitdirectory: "",
					multiple: ""
				});
			}

			this.Lurker.click();
		});
	}
}
